import { useEffect, useRef } from "react";

const FW_COLORS = [
	["#ff6b6b", "#ff4757"],
	["#ffd700", "#ffa502"],
	["#7bed9f", "#2ed573"],
	["#70a1ff", "#1e90ff"],
	["#a29bfe", "#6c5ce7"],
	["#fd79a8", "#e84393"],
	["#55efc4", "#00b894"],
	["#74b9ff", "#0984e3"],
];
const CF_COLORS = ["#f39c12", "#e74c3c", "#2ecc71", "#3498db", "#9b59b6", "#1abc9c", "#e67e22", "#e91e63", "#00bcd4", "#ffeb3b"];

function rnd(a, b) {
	return a + Math.random() * (b - a);
}

class ConfettiPiece {
	constructor(W, H) {
		this.x = rnd(0, W);
		this.y = rnd(-20, -10);
		this.color = CF_COLORS[Math.floor(Math.random() * CF_COLORS.length)];
		this.size = rnd(6, 14);
		this.round = Math.random() > 0.5;
		this.vx = rnd(-1.5, 1.5);
		this.vy = rnd(3, 7);
		this.rot = rnd(0, Math.PI * 2);
		this.rotV = rnd(-0.15, 0.15);
		this.wobble = rnd(0, Math.PI * 2);
		this.wobbleS = rnd(0.05, 0.12);
		this.alive = true;
	}
	update(H) {
		this.wobble += this.wobbleS;
		this.x += this.vx + Math.sin(this.wobble) * 0.8;
		this.y += this.vy;
		this.rot += this.rotV;
		if (this.y > H + 20) this.alive = false;
	}
	draw(ctx) {
		ctx.save();
		ctx.translate(this.x, this.y);
		ctx.rotate(this.rot);
		ctx.globalAlpha = 0.92;
		ctx.fillStyle = this.color;
		if (this.round) {
			ctx.beginPath();
			ctx.arc(0, 0, this.size / 2, 0, Math.PI * 2);
			ctx.fill();
		} else {
			ctx.fillRect(-this.size / 2, -this.size / 4, this.size, this.size / 2);
		}
		ctx.restore();
	}
}

class FWParticle {
	constructor(x, y, color, type, W, H) {
		this.x = x;
		this.y = y;
		this.color = color;
		this.type = type;
		this.trail = [];
		if (type === "spark") {
			const a = rnd(0, Math.PI * 2),
				s = rnd(2, 9);
			this.vx = Math.cos(a) * s;
			this.vy = Math.sin(a) * s;
			this.life = 1;
			this.decay = rnd(0.012, 0.025);
			this.size = rnd(2, 5);
		} else if (type === "star") {
			const a = rnd(0, Math.PI * 2),
				s = rnd(1, 5);
			this.vx = Math.cos(a) * s;
			this.vy = Math.sin(a) * s - 2;
			this.life = 1;
			this.decay = rnd(0.008, 0.018);
			this.size = rnd(1.5, 3.5);
		} else if (type === "ring") {
			const a = rnd(0, Math.PI * 2),
				s = rnd(3, 7);
			this.vx = Math.cos(a) * s;
			this.vy = Math.sin(a) * s;
			this.life = 1;
			this.decay = rnd(0.02, 0.04);
			this.size = rnd(3, 6);
		} else if (type === "glitter") {
			const a = rnd(0, Math.PI * 2),
				s = rnd(0.5, 3);
			this.vx = Math.cos(a) * s;
			this.vy = Math.sin(a) * s - 1;
			this.life = 1;
			this.decay = rnd(0.015, 0.03);
			this.size = rnd(1, 3);
			this.blink = 0;
		} else if (type === "shell") {
			this.x = rnd(W * 0.15, W * 0.85);
			this.y = H + 20;
			this.tx = rnd(W * 0.1, W * 0.9);
			this.ty = rnd(H * 0.05, H * 0.45);
			this.vx = (this.tx - this.x) / 50;
			this.vy = (this.ty - this.y) / 50;
			this.life = 1;
			this.decay = 0.02;
			this.size = 4;
			this.exploded = false;
		}
	}
	update(explodeCb) {
		if (this.type === "shell") {
			if (this.trail.length > 8) this.trail.shift();
			this.trail.push({ x: this.x, y: this.y });
			this.x += this.vx;
			this.y += this.vy;
			this.vy += 0.04;
			this.life -= this.decay;
			if (this.life <= 0 || this.y <= this.ty) {
				this.exploded = true;
				explodeCb(this.x, this.y);
			}
			return;
		}
		if (this.trail.length > 6) this.trail.shift();
		this.trail.push({ x: this.x, y: this.y });
		this.x += this.vx;
		this.y += this.vy;
		this.vy += this.type === "glitter" ? 0.06 : 0.12;
		this.vx *= 0.98;
		this.life -= this.decay;
		if (this.type === "glitter") this.blink += 0.3;
	}
	draw(ctx) {
		ctx.save();
		if (this.type === "shell") {
			for (let i = 0; i < this.trail.length; i++) {
				ctx.globalAlpha = (i / this.trail.length) * 0.6;
				ctx.fillStyle = "#fff";
				ctx.beginPath();
				ctx.arc(this.trail[i].x, this.trail[i].y, 2, 0, Math.PI * 2);
				ctx.fill();
			}
			ctx.globalAlpha = this.life;
			ctx.fillStyle = "#fff";
			ctx.beginPath();
			ctx.arc(this.x, this.y, this.size / 2, 0, Math.PI * 2);
			ctx.fill();
			ctx.restore();
			return;
		}
		const alpha = Math.max(0, this.life);
		for (let i = 0; i < this.trail.length; i++) {
			ctx.globalAlpha = (i / this.trail.length) * alpha * 0.5;
			ctx.fillStyle = this.color;
			ctx.beginPath();
			ctx.arc(this.trail[i].x, this.trail[i].y, this.size * (i / this.trail.length) * 0.7, 0, Math.PI * 2);
			ctx.fill();
		}
		if (this.type === "glitter") {
			ctx.globalAlpha = alpha * (0.5 + 0.5 * Math.abs(Math.sin(this.blink)));
			ctx.fillStyle = "#fff";
			ctx.beginPath();
			ctx.arc(this.x, this.y, this.size * 1.2, 0, Math.PI * 2);
			ctx.fill();
		}
		ctx.globalAlpha = alpha;
		ctx.fillStyle = this.color;
		ctx.beginPath();
		ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
		ctx.fill();
		ctx.restore();
	}
}

const Confetti = () => {
	const canvasRef = useRef(null);

	useEffect(() => {
		const canvas = canvasRef.current;
		const ctx = canvas.getContext("2d");
		let confetti = [],
			fwParticles = [],
			animId;
		let shellCount = 0,
			shellInterval,
			confettiInterval,
			done = false;

		const W = () => canvas.width;
		const H = () => canvas.height;

		const resize = () => {
			canvas.width = window.innerWidth;
			canvas.height = window.innerHeight;
		};
		resize();
		window.addEventListener("resize", resize);

		const explode = (x, y) => {
			const pair = FW_COLORS[Math.floor(Math.random() * FW_COLORS.length)];
			const type = ["spark", "star", "ring", "glitter"][Math.floor(Math.random() * 4)];
			const count = type === "ring" ? 60 : type === "spark" ? 80 : type === "star" ? 70 : 50;
			for (let i = 0; i < count; i++) fwParticles.push(new FWParticle(x, y, Math.random() > 0.5 ? pair[0] : pair[1], type, W(), H()));
			if (Math.random() > 0.5) for (let i = 0; i < 30; i++) fwParticles.push(new FWParticle(x, y, "#fff", "glitter", W(), H()));
		};

		const fireShell = () => fwParticles.push(new FWParticle(0, 0, "#fff", "shell", W(), H()));

		const spawnConfetti = () => {
			for (let i = 0; i < 4; i++) confetti.push(new ConfettiPiece(W(), H()));
		};

		const loop = () => {
			ctx.clearRect(0, 0, W(), H());
			confetti = confetti.filter((p) => {
				p.update(H());
				p.draw(ctx);
				return p.alive;
			});
			fwParticles = fwParticles.filter((p) => {
				p.update(explode);
				if (p.type === "shell" && p.exploded) return false;
				if (p.type !== "shell" && p.life <= 0) return false;
				p.draw(ctx);
				return true;
			});
			animId = requestAnimationFrame(loop);
		};

		loop();
		confettiInterval = setInterval(spawnConfetti, 80);

		shellInterval = setInterval(() => {
			const bursts = shellCount < 5 ? 1 : shellCount < 15 ? 2 : 3;
			for (let i = 0; i < bursts; i++) fireShell();
			shellCount++;
			if (shellCount >= 22) {
				clearInterval(shellInterval);
				clearInterval(confettiInterval);
			}
		}, 360);

		return () => {
			clearInterval(shellInterval);
			clearInterval(confettiInterval);
			cancelAnimationFrame(animId);
			window.removeEventListener("resize", resize);
		};
	}, []);

	return <canvas ref={canvasRef} style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", pointerEvents: "none", zIndex: 9999 }} />;
};

export default Confetti;
